import { render, staticRenderFns } from "./DetailView.vue?vue&type=template&id=0bfb7edc"
import script from "./DetailView.vue?vue&type=script&lang=js"
export * from "./DetailView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports